// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdfxml-pane {
	padding: 1rem;
	border-top: solid 2px var(--color-data-pane-border-top, black);
	border-left: solid 2px var(--color-data-pane-border-top, black);
	border-bottom: solid 2px var(--color-data-pane-border-side, #777);
	border-right: solid 2px var(--color-data-pane-border-side, #777);
	color: var(--color-text-brown, #440);
	box-sizing: border-box;
}

.rdfxml-pane__source {
	overflow-x: auto;
	max-width: 100%;
	box-sizing: border-box;
	font-family: monospace;
	font-size: 120%;
	margin: 0;
	white-space: pre;
}

.rdfxml-pane__line {
	display: grid;
	grid-template-columns: var(--rdfxml-indent, 0) minmax(max-content, auto);
	align-items: start;
}

.rdfxml-pane__line-indent {
	display: block;
	width: var(--rdfxml-indent, 0);
}

.rdfxml-pane__line-content {
	white-space: pre;
}

.rdfxml-pane[data-layout='mobile'] .rdfxml-pane__source {
	overflow-wrap: anywhere;
	word-break: break-word;
	white-space: normal;
}

.rdfxml-pane[data-layout='mobile'] .rdfxml-pane__line {
	grid-template-columns: var(--rdfxml-indent, 0) minmax(0, 1fr);
}

.rdfxml-pane[data-layout='mobile'] .rdfxml-pane__line-content {
	white-space: pre-wrap;
	overflow-wrap: anywhere;
	word-break: break-word;
	min-width: 0;
}

@media (max-width: 576px) {
	.rdfxml-pane__source {
		overflow-wrap: anywhere;
		word-break: break-word;
		white-space: normal;
	}

	.rdfxml-pane__line {
		grid-template-columns: var(--rdfxml-indent, 0) minmax(0, 1fr);
	}

	.rdfxml-pane__line-content {
		white-space: pre-wrap;
		overflow-wrap: anywhere;
		word-break: break-word;
		min-width: 0;
	}
}
`, "",{"version":3,"sources":["webpack://./src/RDFXMLPane.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,8DAA8D;CAC9D,+DAA+D;CAC/D,iEAAiE;CACjE,gEAAgE;CAChE,oCAAoC;CACpC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,sBAAsB;CACtB,eAAe;CACf,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,wEAAwE;CACxE,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,6DAA6D;AAC9D;;AAEA;CACC,qBAAqB;CACrB,uBAAuB;CACvB,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC;EACC,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,6DAA6D;CAC9D;;CAEA;EACC,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;CACb;AACD","sourcesContent":[".rdfxml-pane {\n\tpadding: 1rem;\n\tborder-top: solid 2px var(--color-data-pane-border-top, black);\n\tborder-left: solid 2px var(--color-data-pane-border-top, black);\n\tborder-bottom: solid 2px var(--color-data-pane-border-side, #777);\n\tborder-right: solid 2px var(--color-data-pane-border-side, #777);\n\tcolor: var(--color-text-brown, #440);\n\tbox-sizing: border-box;\n}\n\n.rdfxml-pane__source {\n\toverflow-x: auto;\n\tmax-width: 100%;\n\tbox-sizing: border-box;\n\tfont-family: monospace;\n\tfont-size: 120%;\n\tmargin: 0;\n\twhite-space: pre;\n}\n\n.rdfxml-pane__line {\n\tdisplay: grid;\n\tgrid-template-columns: var(--rdfxml-indent, 0) minmax(max-content, auto);\n\talign-items: start;\n}\n\n.rdfxml-pane__line-indent {\n\tdisplay: block;\n\twidth: var(--rdfxml-indent, 0);\n}\n\n.rdfxml-pane__line-content {\n\twhite-space: pre;\n}\n\n.rdfxml-pane[data-layout='mobile'] .rdfxml-pane__source {\n\toverflow-wrap: anywhere;\n\tword-break: break-word;\n\twhite-space: normal;\n}\n\n.rdfxml-pane[data-layout='mobile'] .rdfxml-pane__line {\n\tgrid-template-columns: var(--rdfxml-indent, 0) minmax(0, 1fr);\n}\n\n.rdfxml-pane[data-layout='mobile'] .rdfxml-pane__line-content {\n\twhite-space: pre-wrap;\n\toverflow-wrap: anywhere;\n\tword-break: break-word;\n\tmin-width: 0;\n}\n\n@media (max-width: 576px) {\n\t.rdfxml-pane__source {\n\t\toverflow-wrap: anywhere;\n\t\tword-break: break-word;\n\t\twhite-space: normal;\n\t}\n\n\t.rdfxml-pane__line {\n\t\tgrid-template-columns: var(--rdfxml-indent, 0) minmax(0, 1fr);\n\t}\n\n\t.rdfxml-pane__line-content {\n\t\twhite-space: pre-wrap;\n\t\toverflow-wrap: anywhere;\n\t\tword-break: break-word;\n\t\tmin-width: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
